import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";

const avatarMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function PostsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-600">热门讨论</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              漫圈最新讨论
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              从剧情解读到cp发糖，从推理分析到求安利。来看看同好们正在聊什么。
            </p>
            <Link
              to="/circles"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
            >
              去逛漫圈 <i className="ri-arrow-right-line" />
            </Link>

            <div className="mt-8 rounded-2xl border border-accent-200 bg-accent-100/70 p-5">
              <div className="flex items-center gap-2 text-accent-700">
                <i className="ri-sparkling-2-line text-xl" />
                <span className="font-heading text-base">今天想聊什么？</span>
              </div>
              <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-700">
                在漫圈发起一个新话题，认识同好，从一句"你也追这部？"开始。来这里混个脸熟，追漫有人陪聊。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {posts.map((p) => (
              <Link
                key={p.id}
                to="/circles"
                className="group rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5 hover:border-primary-300 hover:bg-background-50 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <span className={`mt-0.5 grid h-10 w-10 shrink-0 place-items-center rounded-full text-sm font-bold ${avatarMap[p.avatarColor]}`}>
                    {p.author.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-full px-2.5 py-0.5 text-xs ${avatarMap[p.avatarColor]}`}>
                        {p.circle}
                      </span>
                      <span className="rounded-full bg-background-200/70 px-2.5 py-0.5 text-xs text-foreground-600">
                        {p.tag}
                      </span>
                      {p.hot && (
                        <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                          <i className="ri-fire-fill" /> 热
                        </span>
                      )}
                    </div>
                    <h3 className="mt-2 font-heading text-base md:text-lg leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {p.title}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm leading-6 text-foreground-600 line-clamp-2">
                      {p.excerpt}
                    </p>
                    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span>{p.author}</span>
                      <span>{p.time}</span>
                      <span className="inline-flex items-center gap-1"><i className="ri-eye-line" />{p.views}</span>
                      <span className="inline-flex items-center gap-1"><i className="ri-message-3-line" />{p.replies}</span>
                      <span className="inline-flex items-center gap-1"><i className="ri-heart-3-line" />{p.likes}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}